import styled from 'styled-components'
import ActionButton from 'src/components/ActionButton'
import { Label } from 'src/form/fields/FormFieldInput/styled'

import FormSubmitButton from '../../form/FormSubmitButton'
import FormFieldEmail from '../../form/fields/FormFieldEmail'
import FormFieldInput from '../../form/fields/FormFieldInput'
import FormikForm from '../../form/FormikForm'
import { mq, sizes } from '../../theme'

export const Container = styled.div`
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const Form = styled(FormikForm)`
  width: fit-content;
`

export const Fields = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: center;
  gap: 3rem;
`

export const EmailField = styled(FormFieldEmail)`
  min-width: 100%;

  @media ${mq(sizes.mobile)} {
    min-width: 45.1rem;

    ${Label} {
      align-self: center;
      margin-bottom: 0;
    }
  }
`

export const TextField = styled(FormFieldInput)`
  ${Label} {
    white-space: nowrap;
  }

  min-width: 100%;

  @media ${mq(sizes.mobile)} {
    min-width: 45.1rem;

    @media ${mq(sizes.mobile)} {
      min-width: 45.1rem;

      ${Label} {
        align-self: center;
        margin-bottom: 0;
      }
    }
  }
`

export const Actions = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 1rem;
  margin: 2rem auto 0 auto;
`

export const ForgottenButton = styled(FormSubmitButton)`
  height: 4rem;
`
export const SubmitButton = styled(FormSubmitButton)`
  height: 4rem;
`
export const _ActionButton = styled(ActionButton)`
  height: 4rem;
`
